module.exports = __webpack_public_path__ + "be60fb1134387654f71d4235c1458557.svg";